// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonComponent } from '../button/button.component';

export type ToastDto = {
  id: string;
  message: string;
  type: 'success' | 'error' | 'feedback';
  duration?: number | null;
  dismissible?: boolean;
  isExiting?: boolean;
  action?: {
    text: string;
    route: string[];
  };
};

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, ButtonComponent],
  templateUrl: './toast.component.html',
  host: {
    '[style.width]': '"100%"',
    '[style.display]': '"flex"',
    '[style.justify-content]': '"end"',
  },
})
export class ToastComponent {
  // Inputs
  public readonly toast = input.required<ToastDto>();

  // Outputs
  public dismissed = output<string>();
  public actionClicked = output<ToastDto>();
}
